<template>
    <div class="row">
        <h2>wakka</h2>
        <div class="col-5">
            <b-breadcrumb>
                <b-breadcrumb-item :to="to" active>
                    {{name}}
                </b-breadcrumb-item>
                <b-breadcrumb-item>
                </b-breadcrumb-item>
            </b-breadcrumb>
        </div>
    </div>
</template>

<script>
import {mapState} from "vuex";

export default {
    name: "AdoptionBreadcrumb",
    compupted: mapState({
        customerId: state => state.adoption.adoptionData.customerId
    }),
    props: ['name', 'to']
}
</script>

<style scoped>

</style>